<template>
    <vx-expandable-card>
        <template v-slot:header>
            <div class="flex flex-col items-start">
                Included Fields
                <span class="text-sm font-normal text-slate-500">
                    These are the fields included in all exports. They can't be edited.
                </span>
            </div>

        </template>
        <template v-slot:content>
            <ul class="pl-3 list-disc text-sm text-slate-500">
                <li v-for="key in RESERVED_CUTOM_ATTRIBUTE_KEYS" :key="key">
                    {{ key }}
                </li>
            </ul>
        </template>

    </vx-expandable-card>
</template>
<script setup>
import { VxExpandableCard } from '@voxie/frontend-components';
import { RESERVED_CUTOM_ATTRIBUTE_KEYS } from '~/utils/customAttributes';

</script>
